import { env } from "@/lib/env";
import { getConfiguredApiBaseAddress } from "@osn/auth";

const DEFAULT_API_SURFACE = "playapi";
const SCHEDULES_API_SURFACE = "schedules";

/** The tenant a portal request belongs to. A plain object so it can cross the server/client boundary. */
export type PortalTenant = {
  /** The tenant's registry name (e.g. `gridiron`). */
  name: string;
  /** The tenant's display name; empty when it is not known. */
  displayName: string;
  firebaseTenantId: string;
  /** The tenant's API origin with no surface prefix; empty when the environment configures the API address instead. */
  apiBaseUrl: string;
};

/** The address of this portal's API surface for the tenant, or the configured environment address. */
export function getTenantApiBaseAddress(tenant: PortalTenant): string | undefined {
  if (tenant.apiBaseUrl) {
    return `${trimTrailingSlashes(tenant.apiBaseUrl)}/${env.NEXT_PUBLIC_SERVICE_NAME ?? DEFAULT_API_SURFACE}`;
  }

  return env.NEXT_PUBLIC_API_BASE_ADDRESS;
}

/** The address of the schedules API for the tenant, or the configured environment address. */
export function getTenantSchedulesApiBaseAddress(tenant: PortalTenant): string | undefined {
  if (tenant.apiBaseUrl) {
    return `${trimTrailingSlashes(tenant.apiBaseUrl)}/${SCHEDULES_API_SURFACE}`;
  }

  return env.NEXT_PUBLIC_SCHEDULES_API_BASE_ADDRESS;
}

/** The API address requests are sent to, as configured by the tenant provider or the environment. */
export function getApiBaseAddress(): string {
  const address = getConfiguredApiBaseAddress() || env.NEXT_PUBLIC_API_BASE_ADDRESS;

  if (!address) {
    throw new Error("No API address is configured for this portal.");
  }

  return address;
}

function trimTrailingSlashes(value: string) {
  return value.trim().replace(/\/+$/, "");
}
